'use strict';

(function () {
    var shellPackages = [
        { name: "suiteux.shell.header", resourceLoader: function () { require("./js/suiteux.shell.header"); } },
        { name: "suiteux.shell.responsive", resourceLoader: function () { require("./js/suiteux.shell.responsive"); } }
    ];

    require("./js/suiteux.shell.bootstrapper");

    shellPackages.forEach(function (shellPackage) {
        O365Shell.SetLoadPackageHandler(shellPackage.name, function (successHandler, failureHandler) {
            try {
                shellPackage.resourceLoader();
                if (shellPackage.name == "suiteux.shell.header") {
                    // Once the header package is loaded, we need to reset the exported O365Shell instance to the updated shim instance
                    // in the global namespace
                    exports.O365Shell = window.O365Shell;
                }

                if (successHandler) {
                    successHandler();
                }
            } catch (exception) {
                if (failureHandler) {
                    failureHandler({
                        ResourceName: shellPackage.name,
                        Details: "SetLoadPackageHandler failure: " + exception.message
                    });
                }
            }
        });
    });
})();

exports.O365Shell = window.O365Shell;
